/**
 * Ciokarrua · Card eyebrow positioner
 * Sposta .cio-card-eyebrow immediatamente prima del titolo del prodotto in
 * ogni product-card. Funziona con cards aggiunte dinamicamente (filtri/paginazione).
 */
(function () {
  const log = function () {
    if (window.location.search.includes('cio_debug=1')) {
      console.log.apply(console, ['[cio-eyebrow]'].concat(Array.from(arguments)));
    }
  };

  function findTitle(card) {
    return (
      card.querySelector('a[ref="productTitleLink"]') ||
      card.querySelector('[ref="productTitleLink"]') ||
      card.querySelector('product-title-block') ||
      card.querySelector('product-title') ||
      card.querySelector('[class*="product-title"]') ||
      card.querySelector('[role="heading"]') ||
      card.querySelector('.product-card__title') ||
      null
    );
  }

  function repositionEyebrow(card) {
    const eyebrow = card.querySelector('.cio-card-eyebrow[data-cio-eyebrow]');
    if (!eyebrow || eyebrow.dataset.positioned === '1') return;
    const title = findTitle(card);
    if (!title) {
      log('no title found in card', card);
      return;
    }
    title.parentNode.insertBefore(eyebrow, title);
    eyebrow.dataset.positioned = '1';
    log('positioned before', title);
  }

  function processAll() {
    document.querySelectorAll('product-card, .product-card').forEach(repositionEyebrow);
  }

  if (document.readyState !== 'loading') {
    processAll();
  } else {
    document.addEventListener('DOMContentLoaded', processAll);
  }

  // Re-process per cards aggiunte dinamicamente (filtri S&D, paginazione, ecc.)
  const obs = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('product-card, .product-card') || n.querySelector?.('product-card, .product-card')) {
          processAll();
          return;
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
